import { render, staticRenderFns } from "./ShareBlock.vue?vue&type=template&id=4a582345&"
import script from "./ShareBlock.vue?vue&type=script&lang=js&"
export * from "./ShareBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShareBlock.vue"
export default component.exports